import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=acb54af8&"
import script from "./InviteModal.vue?vue&type=script&lang=ts&"
export * from "./InviteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports